export default __webpack_public_path__ + "0a50ec058e8f243edb57732853f1a675.png";